<div class="ov-container">
  <ov-videoconference
    [token]="token"
    [livekitUrl]="LIVEKIT_URL"
    [participantName]="defaultParticipantName"
    (onTokenRequested)="onTokenRequested($event)"
    (onRoomDisconnected)="onRoomDisconnected()"
  >
  </ov-videoconference>
</div>